import {api} from '../../../utils/api'

export default {

    /**
     * Load time injector
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    load({commit}, id) {
        return api.call(commit, 'get', '/api/time-injectors/'+id, null, 'SET_INJECTORS');
    },

 /**
  * Load time injector by task
  * @param commit
  * @param task_id
  * @returns {*|Promise|Promise<any>}
  */
    loadByTask({commit}, task_id) {
        return api.call(commit, 'get', '/api/time-injectors/task/'+task_id, null, 'SET_INJECTORS');
    },


    /**
     * Save injector data
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    save({commit}, payload) {
        return api.call(commit, 'patch', '/api/time-injectors/' + (payload.id ? payload.id : 0), payload, 'SET_INJECTORS');
    },

    /**
     * Delete injectors
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    delete({commit}, payload) {
        return api.call(commit, 'delete', '/api/time-injectors/' + payload.id, null, 'DELETE_INJECTORS');
    },
}
